import { GLOBALS } from '@wix/communities-blog-client-common';
import { appendOriginInBackend, appendAuthHeaders } from '../../common/controller/helpers';
import { getQueryLocale } from '../../common/selectors/locale-selectors';
import { archiveWidgetFailure, handleArchiveWidgetResponse } from '../aggregated-archive/actions';
import type { ArchiveWidgetThunkAction } from '../types';

type FetchArchiveWidgetInitialDataArgs = {
  showNewestPostsFirst: boolean;
  monthsDisplayLimit: number;
};

export const fetchArchiveWidgetInitialData =
  ({
    showNewestPostsFirst = true,
    monthsDisplayLimit = 12,
  }: FetchArchiveWidgetInitialDataArgs): ArchiveWidgetThunkAction =>
  async (dispatch, getState, { httpClient, platformApi, errorHandler }) => {
    const state = getState();
    const langQuery = getQueryLocale(state);
    const language = langQuery ? `&language=${langQuery}` : '';
    const timeZone = platformApi.site.timezone ? `&timeZone=${platformApi.site.timezone}` : '';
    const { withErrorHandler } = errorHandler;

    try {
      const { data: response } = await withErrorHandler(
        () =>
          httpClient.get(
            appendOriginInBackend({
              platformApi,
              baseUrl: `${GLOBALS.API_FRONTEND_ADAPTER_BASE_URL}/v1/archive-widget/render-model?months=${monthsDisplayLimit}&showNewestPostsFirst=${showNewestPostsFirst}${timeZone}${language}`,
            }),
            {
              headers: appendAuthHeaders(platformApi),
            },
          ),
        { errorCodesMap: {} },
      );

      if (response && typeof response === 'object' && 'archive' in response) {
        await dispatch(handleArchiveWidgetResponse(response.archive));
      } else {
        throw new Error('Invalid response');
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'status' in error && error.status === 429) {
        return dispatch(archiveWidgetFailure(error.status));
      }

      throw error;
    }
  };
